import React from "react";
import PropTypes from "prop-types";
import { range } from "lodash";

import { Grid, Placeholder, Segment } from "..";

function PlanCardPlaceholder({ totalCards }) {
  return (
    <Grid columns={totalCards} data-test="plan-card-loader">
      {range(totalCards).map((i) => {
        return (
          <Grid.Column key={i}>
            <Segment raised style={{ minHeight: "400px", padding: "1.8em" }}>
              <Placeholder style={{ marginTop: "2em" }}>
                <Placeholder.Header>
                  <Placeholder.Line length="medium" />
                  <Placeholder.Line length="short" />
                  <Placeholder.Line length="medium" />
                </Placeholder.Header>
              </Placeholder>
              <Placeholder style={{ marginTop: "3.5em" }}>
                <Placeholder.Header>
                  <Placeholder.Line />
                  <Placeholder.Line />
                  <Placeholder.Line />
                  <Placeholder.Line />
                  <Placeholder.Line length="medium" />
                  <Placeholder.Line />
                  <Placeholder.Line />
                  <Placeholder.Line />
                  <Placeholder.Line length="short" />
                  <Placeholder.Line />
                </Placeholder.Header>
              </Placeholder>
            </Segment>
          </Grid.Column>
        );
      })}
    </Grid>
  );
}

PlanCardPlaceholder.propTypes = { totalCards: PropTypes.number };

PlanCardPlaceholder.defaultProps = { totalCards: 3 };

export default PlanCardPlaceholder;
